var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThFiltered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.333 10 1.435-1.722a1 1 0 0 0 .232-.64V4.85l1-.9V18c0 .5-.5 1-1 1H1c-.6 0-1-.5-1-1V2c0-.5.4-1 1-1h6.722L12 4.85V6H8v3h4v1H8v3h10v-3h-.667ZM7 17v-3H2v3h5Zm0-4v-3H2v3h5Zm0-4V6H2v3h5Zm11 8v-3H8v3h10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.35 0a.642.642 0 0 1 .46 1.1l-3.03 3.03v2.95c0 .18-.07.34-.19.46l-1.28 1.29c-.11.1-.27.17-.45.17-.35 0-.64-.29-.64-.64V4.13L11.19 1.1a.642.642 0 0 1 .45-1.1h7.71Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThFiltered);
export default __webpack_public_path__ + "static/media/th-filtered.c6d5cbde23739890a4e82ccb9bad348e.svg";
export { ForwardRef as ReactComponent };